import React, { useState } from "react";
import Api from "../../../../lib/componentApi";

import Loading from "../../../../components/Common/Loading";

const settingsData = [
  {
    id: 1,
    title: "Promotional News",
    description:
      "Send me great deals and news about my local food heroes on Local E.",
    notificationSettingName: "promotionAppNotification",
    emailSettingName: "promotionEmail"
  },
  {
    id: 2,
    title: "Order Updates",
    description:
      "Keep these on if you want to keep up to date with your delivery tracking details.",
    notificationSettingName: "orderUpdates",
    emailSettingName: "orderUpdates"
  }
];

const Marketing = ({ onCloseSection, notificationSettings, updateUser }) => {
  const [marketingData, setMarketingData] = useState(notificationSettings);
  const [loading, setLoading] = useState(false);
  const handleChangeInput = e => {
    const { checked, name } = e.target;
    setMarketingData({ ...marketingData, ...{ [name]: checked } });
  };
  let diff = () =>
    Object.keys(marketingData).filter(
      k => marketingData[k] !== notificationSettings[k]
    );

  const canUserSave = () => {
    const isObjectDifferent = diff().length;
    return !!isObjectDifferent;
  };
  const handleSubmitNotificationSettings = () => {
    setLoading(true);
    Api.post(
      "/api/set/notification/settings",
      marketingData,
      (response, errors) => {
        if (errors) {
          if (errors === 503) {
            this.setState(() => {
              throw errors;
            });
          } else {
            console.log(errors);
          }
        } else if (response.code) {
          console.log(response, "code notification settings");
        } else {
          updateUser({ shouldUpdate: true });
        }
        setLoading(false);
      }
    );
  };
  return (
    <div className="profile-desktop market-settings">
      {/* Header */}
      <div className="head-general with-back">
        <a
          href="javascript: void(0)"
          onClick={() => onCloseSection("settingsSection")}
          className="back"
        >
          <img src="/png/chevron-left.png" />
        </a>
        <h4>Marketing Settings</h4>
        <a
          href="javascript: void(0)"
          onClick={() => onCloseSection("settingsSection")}
          className="close"
        >
          <i className="icon icon-close" />
        </a>
      </div>
      {/* Header */}
      <h4 className="hide-xs general-title">Marketing Settings</h4>
      <div className="white-bg offline mt-10px">
        {settingsData.map(setting => (
          <div className="item">
            <div>
              <h5 className="bold">{setting.title}</h5>
              <p>{setting.description}</p>
            </div>
            {setting.emailSettingName && (
              <div className="d-flex justify-content-between align-items-center">
                <label
                  style={{
                    color:
                      setting.emailSettingName === "orderUpdates" &&
                      "rgb(190, 194, 201)"
                  }}
                >
                  Email
                </label>
                <div class="check square">
                  <label htmlFor={`email${setting.id}`}>
                    <input
                      id={`email${setting.id}`}
                      type="checkbox"
                      disabled={setting.emailSettingName === "orderUpdates"}
                      onChange={handleChangeInput}
                      name={setting.emailSettingName}
                      checked={
                        setting.emailSettingName === "orderUpdates"
                          ? true
                          : marketingData[setting.emailSettingName]
                      }
                    />
                    <span className="checkmark" />
                  </label>
                </div>
              </div>
            )}
            {setting.notificationSettingName && (
              <div className="d-flex justify-content-between align-items-center">
                <label
                  style={{
                    color:
                      setting.notificationSettingName === "orderUpdates" &&
                      "rgb(190, 194, 201)"
                  }}
                >
                  App Notification
                </label>
                <div class="check square">
                  <label htmlFor={`app${setting.id}`}>
                    <input
                      id={`app${setting.id}`}
                      type="checkbox"
                      disabled={
                        setting.notificationSettingName === "orderUpdates"
                      }
                      name={setting.notificationSettingName}
                      onChange={handleChangeInput}
                      checked={
                        setting.notificationSettingName === "orderUpdates"
                          ? true
                          : marketingData[setting.notificationSettingName]
                      }
                    />
                    <span className="checkmark" />
                  </label>
                </div>
              </div>
            )}
          </div>
        ))}
        <div className="use-buttons">
          <button
            onClick={handleSubmitNotificationSettings}
            className={(canUserSave() && "btn btn-blue") || "btn btn-gray"}
          >
            <span>Save</span>
          </button>
        </div>
      </div>

      {loading && <Loading />}
    </div>
  );
};

export default Marketing;
